import { Card, Col, Row, Skeleton, message,Space,Popover } from "antd";
import ECard from "components/ECard";
import { ColoredStatistic } from "components/Jarvis";
import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import SettlementHistogram from "components/SettlementHistogram";
import { useQuery } from "react-query";
import { getSettlementSummary } from "api/SettlementApi"
import {InfoCircleOutlined} from "@ant-design/icons"


const formatter = (value) => <CountUp end={value} separator="," />;

export default function SettlementDashboardPage() {

  const [apiData,setApiData]=useState()
  const { refetch, data } = useQuery("getSettlementSummary", () => getSettlementSummary(), {
    onSuccess: (res) => {
      if (res.code != 200) {        
        message.info("Please contact us")
      }else{
        setApiData(res.payload)
      }
    }
  });
  useEffect(() => {
    refetch()
  }, [])

  return (
    <Row gutter={[16, 16]}>
      {console.log("data", apiData)}
      <Col span={24}>
      <ECard>
          <Card.Grid style={{ width: "20%" }} hoverable={false}>
            <ColoredStatistic title="Today Volumn" value={apiData?.today_volumn} precision={2} formatter={formatter} />
          </Card.Grid>
          <Card.Grid style={{ width: "20%" }} hoverable={false}>
            <ColoredStatistic title="Today Net Amount " value={apiData?.today_net_amount} precision={2} formatter={formatter} />
          </Card.Grid>
          <Card.Grid style={{ width: "20%" }} hoverable={false}>
            <ColoredStatistic title="Today Fee Amount" value={apiData?.today_fee_amount} precision={2} formatter={formatter} />
          </Card.Grid>
          <Card.Grid style={{ width: "20%" }} hoverable={false}>
            <ColoredStatistic title="Today Adjustment Amount" value={apiData?.today_adjustment} precision={2} formatter={formatter} />
          </Card.Grid>
          <Card.Grid style={{ width: "20%" }} hoverable={false}>
            <ColoredStatistic title="Today Settle Amount" value={apiData?.today_settle_amount} precision={2} formatter={formatter} />
          </Card.Grid>
          <Card.Grid style={{ width: "20%" }} hoverable={false}>
            <ColoredStatistic title="Total Volumn" value={apiData?.total_volumn} precision={2} formatter={formatter} />
          </Card.Grid>
          <Card.Grid style={{ width: "20%" }} hoverable={false}>
            <ColoredStatistic title="Total Net Amount " value={apiData?.total_net_amount} precision={2} formatter={formatter} />
          </Card.Grid>
          <Card.Grid style={{ width: "20%" }} hoverable={false}>
            <ColoredStatistic title="Total Fee Amount" value={apiData?.total_fee_amount} precision={2} formatter={formatter} />
          </Card.Grid>
          <Card.Grid style={{ width: "20%" }} hoverable={false}>
            <ColoredStatistic title="Total Adjustment Amount" value={apiData?.total_adjustment} precision={2} formatter={formatter} />
          </Card.Grid>
          <Card.Grid style={{ width: "20%" }} hoverable={false}>
            <ColoredStatistic title="Total Settle Amount" value={apiData?.total_settle_amount} precision={2} formatter={formatter} />
          </Card.Grid>
        </ECard>
      </Col>
 
      <Col span={24}>
        <ECard title={<><Space>Settlement  <Popover content="It show 90 days settlement data" >
            <InfoCircleOutlined />
          </Popover></Space></>}>
          <SettlementHistogram />
        </ECard>
      </Col>
    </Row>
  );
}
